import { render } from "./brand-values.vue?vue&type=template&id=71713bd8"
import script from "./brand-values.vue?vue&type=script&lang=js"
export * from "./brand-values.vue?vue&type=script&lang=js"

import "./brand-values.vue?vue&type=style&index=0&id=71713bd8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__